import api from '../client';

export const MailService = {
  getAccount: () => api.get('/mail/account'),
  getAdminAccountForUser: (userId) => api.get(`/mail/admin/account/${userId}`),
  configureAdminAccountForUser: (userId, data) => api.post(`/mail/admin/account/${userId}`, data),
  getInbox: (folder = 'inbox') => api.get(`/mail/inbox?folder=${folder}`),
  sendMail: (data) => api.post('/mail/send', data),
  markRead: (id) => api.patch(`/mail/${id}/read`),
  
  getFolders: () => api.get('/mail/folders'),
  createFolder: (name) => api.post('/mail/folders', { name }),
  deleteFolder: (id) => api.delete(`/mail/folders/${id}`),
  
  getRules: () => api.get('/mail/rules'),
  createRule: (data) => api.post('/mail/rules', data),
  deleteRule: (id) => api.delete(`/mail/rules/${id}`),
  downloadAttachment: (msgId, attachmentId) => api.get(`/mail/attachments/${msgId}/${attachmentId}`, { responseType: 'blob' }),
  saveAttachmentToFolder: (msgId, attachmentId, folderId) => api.post(`/mail/attachments/${msgId}/${attachmentId}/save-to-folder`, { folder_id: folderId }),
  attachToTask: (msgId, attachmentId, data) => api.post(`/mail/attachments/${msgId}/${attachmentId}/attach-to-task`, data)
};
